import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.contatListTabAction.alertTitle, 'Alert'),
  cancel: () => __(translations.contatListTabAction.cancel, 'Cancel'),
  yesImSure: () => __(translations.contatListTabAction.yesImSure, "Yes, I'm sure"),
  detachMessage: () => __(translations.contatListTabAction.detachMessage, 'Are you sure you want to detach this contact?'),
};
